<template>
  <el-drawer
    :title="title"
    :append-to-body="open"
    :visible.sync="drawer"
    size="80%"
    ref="drawerRef"
    v-loading.fullscreen.lock="loading"
    :with-header="true"
    v-bind="$attrs"
  >
    <el-container>
      <el-main>
        <el-row>
          <el-col>
            <el-form
              :model="data"
              label-position="left"
              size="mini"
              label-width="120px"
            >
              <h2 style="margin-bottom: 0px">
                {{ data.ServiceRequestType.Description }}
              </h2>
              <el-badge :value="data.StatusDescription" type="primary">
              </el-badge>

              <div style="display: block" class="ctn-comments">
                <div style="margin-left: 75px">
                  <h2>Comentario</h2>
                  <quill-editor
                    disabled
                    ref="myQuillEditor"
                    v-model="data.Comments"
                    style="height: 150px; margin-bottom: 150px; width: 90%"
                  >
                  </quill-editor>
                </div>

                <div style="margin-left: 75px" class="ctn-moreDetails">
                  <h2>Más detalles</h2>
                  <quill-editor
                    disabled
                    ref="myQuillEditor"
                    v-model="data.MoreDetails"
                    style="height: 575px; margin-bottom: 150px; width: 90%"
                  >
                  </quill-editor>
                </div>
              </div>
              <el-row :gutter="20" class="mt-20" type="flex column">
                <el-col :span="8" :xs="8" :sm="24" :md="24" :lg="12">
                  <el-form-item
                    label="Tipo de solicitud"
                    :value="data.ServiceRequestType.Description"
                  >
                    <el-input
                      v-model="data.ServiceRequestType.Description"
                      :disabled="true"
                    ></el-input>
                  </el-form-item>

                  <el-form-item
                    label="Producto"
                    :value="data.Product.Description"
                  >
                    <el-input
                      v-model="data.Product.Description"
                      :disabled="true"
                    ></el-input>
                  </el-form-item>

                  <el-form-item
                    label="Creada por"
                    :value="data.Product.Description"
                  >
                    <el-input
                      v-model="data.CreatedByUser.FullName"
                      :disabled="true"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8" :xs="8" :sm="24" :md="24" :lg="12">
                  <el-form-item label="Cliente" :value="data.Customer.Name">
                    <el-input
                      v-model="data.Customer.Name"
                      :disabled="true"
                    ></el-input>
                  </el-form-item>
                  <el-form-item
                    label="Tel. Cliente"
                    :value="data.Customer.PhoneNumber"
                  >
                    <el-input
                      v-model="data.Customer.PhoneNumber"
                      :disabled="true"
                    ></el-input>
                  </el-form-item>
                  <el-form-item
                    label="Dir. Cliente"
                    :value="data.Customer.Address"
                  >
                    <el-input
                      v-model="data.Customer.Address"
                      :disabled="true"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8" :xs="8" :sm="24" :md="24" :lg="12">
                  <el-form-item label="Contacto" :value="data.Contact.Name">
                    <el-input
                      v-model="data.Contact.Name"
                      :disabled="true"
                    ></el-input>
                  </el-form-item>
                  <el-form-item
                    label="Tel. Contacto"
                    :value="data.Contact.PhoneNumber"
                  >
                    <el-input
                      v-model="data.Contact.PhoneNumber"
                      :disabled="true"
                    ></el-input>
                  </el-form-item>
                  <el-form-item
                    label="Email Contacto"
                    :value="data.Contact.Email"
                  >
                    <el-input
                      v-model="data.Contact.Email"
                      :disabled="true"
                    ></el-input>
                  </el-form-item>
                </el-col>

                <el-col :span="8" :xs="8" :sm="24" :md="24" :lg="12">
                  <el-form-item label="Diagnóstico" :value="data.Diagnostic">
                    <el-input
                      v-model="data.Diagnostic"
                      :disabled="true"
                    ></el-input>
                  </el-form-item>
                  <el-form-item
                    label="Solución Definitiva"
                    :value="data.Solution"
                  >
                    <el-input
                      type="textarea"
                      v-model="data.Solution"
                      :disabled="true"
                    ></el-input>
                  </el-form-item>
                </el-col>

                <el-col :span="8" :xs="8" :sm="24" :md="24" :lg="12">
                  <el-form-item label="Archivo" v-if="data.AttachmentFileName">
                    <el-upload
                      action="#"
                      disabled
                      multiple
                      list-type="picture-card"
                      :auto-upload="false"
                      :file-list="[
                        {
                          name: data.AttachmentFileName,
                          url: data.AttachmentUrl
                        }
                      ]"
                    >
                      <i slot="default" class="el-icon-plus"></i>
                      <div slot="file" slot-scope="{ file }">
                        <img
                          class="el-upload-list__item-thumbnail"
                          :src="getFilePreview(data.AttachmentFileName)"
                          alt=""
                        />
                        <span class="el-upload-list__item-actions">
                          <span
                            class="el-upload-list__item-delete"
                            @click="handleDownload(file)"
                          >
                            <i class="el-icon-download"></i>
                          </span>
                        </span>
                      </div>
                    </el-upload>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col>
                  <el-tabs v-model="activeName">
                    <el-tab-pane label="Log de solicitudes" name="logs">
                      <el-table :data="data.RequestsMovements" border fit>
                        <el-table-column
                          prop="CreatedByUser.FullName"
                          label="Usuario"
                        />
                        <el-table-column prop="Action" label="Accion" />
                        <el-table-column
                          prop="FullNameValidationEmployeeID"
                          label="Validado Por"
                        />
                        <el-table-column prop="Comment" label="Comentario" />
                        <el-table-column prop="CreatedAt" label="Fecha" />
                      </el-table>
                    </el-tab-pane>
                    <el-tab-pane
                      label="Dispositivos requeridos"
                      name="requiredDevices"
                    >
                      <el-table
                        :data="data.RequestDeviceTypeQuantities"
                        border
                        fit
                      >
                        <el-table-column
                          prop="DeviceType.Description"
                          label="Tipo de dispotivo"
                        />
                        <el-table-column prop="Quantity" label="Cantidad" />
                      </el-table>
                    </el-tab-pane>
                    <el-tab-pane
                      label="Solicitudes a instaladores"
                      name="third"
                    >
                      <el-table :data="data.DeviceOperationRequests" border fit>
                        <el-table-column
                          prop="Technician.FullName"
                          label="Instalador"
                        />
                        <el-table-column
                          prop="Device.DeviceType.Description"
                          label="Tipo de dispositivo"
                          min-width="150"
                        />
                        <el-table-column
                          prop="Device.Description"
                          label="Modelo Dispositivo"
                          min-width="150"
                        />
                        <el-table-column
                          prop="Quantity"
                          label="Cantidad"
                          width="80"
                        />
                        <el-table-column
                          prop="StatusDescription"
                          label="Estatus"
                        />
                        <el-table-column
                          prop="Comment"
                          label="Comentario creacion"
                          min-width="150"
                        />
                        <el-table-column
                          prop="CloseComment"
                          label="Comentario cierre"
                          min-width="150"
                        />
                      </el-table>
                    </el-tab-pane>
                    <el-tab-pane
                      label="Dispositivos en solicitud"
                      name="fourth"
                    >
                      <el-table :data="data.RequestedDevices" border fit>
                        <el-table-column
                          prop="DeviceModel.Description"
                          label="Modelo"
                        />
                        <el-table-column
                          prop="Installer.FullName"
                          label="Instalador"
                        />
                        <el-table-column prop="Serial" label="Serial" />
                        <el-table-column prop="SIMNumber" label="Numero SIM" />
                        <el-table-column prop="IMEI" label="IMEI" />
                      </el-table>
                    </el-tab-pane>
                  </el-tabs>
                </el-col>
              </el-row>
            </el-form>
          </el-col>
        </el-row>
      </el-main>
    </el-container>
  </el-drawer>
</template>

<script>
import { quillEditor } from "vue-quill-editor";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
export default {
  inheritAttrs: false,
  name: "RequestForm",
  props: {
    open: {
      default: false
    }
  },
  data() {
    return {
      filePreview: {
        pdf: "https://www.iconfinder.com/data/icons/line-icons-set/128/1-02-512.png",
        xls: "https://www.iconfinder.com/data/icons/file-formats-7/502/Untitled-26-512.png",
        docx: "https://img.icons8.com/color/100/000000/word.png"
      },
      id: 0,
      title: "",
      activeName: "logs",
      drawer: false,
      loading: false,
      data: {
        Status: 0,
        Target: 0,
        TargetDescription: "",
        StatusDescription: "",
        AssignedTechnicianId: null,
        AssignedTechnician: null,
        RequestDate: "",
        ServiceRequestType: {
          Description: "",
          CanHaveDevices: false,
          ForceDeviceRegistration: false,
          OperationType: 0,
          IconUrl: "",
          Products: null,
          DepartmentId: 0,
          Department: null,
          SlaType: 0,
          Id: 0,
          IsEnabled: false,
          IsNull: false
        },
        ServiceRequestTypeId: 0,
        ProductId: 0,
        Product: {
          CompanyId: "",
          Description: "",
          LogoUrl: "",
          Codes: "",
          DimensionValueCode: "",
          ServiceAccountMainCode: null,
          IsVisible: false,
          ServiceRequestTypes: [],
          DeviceTypes: [],
          Id: 0,
          IsEnabled: false,
          IsNull: false
        },
        RequestDeviceTypeQuantities: [
          {
            RequestId: 0,
            Request: null,
            DeviceTypeId: 0,
            DeviceType: {
              Description: "",
              FixedAssetType: 0,
              RequiresSIM: false,
              Products: null,
              Id: 0,
              IsEnabled: false,
              IsNull: false
            },
            Quantity: 0,
            Id: 0,
            IsEnabled: false,
            IsNull: false
          }
        ],
        DeviceOperationRequests: [],
        RequestedDevices: [],
        RequestsMovements: [],
        Comments: "",
        ServiceIsFree: false,
        RequiresInstallersCoordination: false,
        RequiresDeviceRegistration: false,
        SLAHoursToRespond: 0,
        DueDate: "",
        CloseDate: null,
        PartialDeviceQuantity: 0,
        AttachmentUrl: "",
        AttachmentFileName: null,
        DeviceQuantity: 0,
        ServiceRequestCloseDate: null,
        CompanyCode: "",
        ContractCode: null,
        CustomerIdentification: "",
        ClientCode: "",
        CustomerName: "",
        Customer: {
          Name: "",
          ClientCode: "",
          Address: "",
          City: "",
          Sector: "",
          Contact: "",
          PhoneNumber: "",
          SalesPersonName: "",
          SalesPersonCode: "",
          Email: "",
          VatRegistrationNumber: "",
          PrimaryContactNumber: "",
          PrimaryContactName: "",
          CompanyId: "",
          Date_Login: null,
          Date_Logoff: null,
          CurrencyCode: "",
          Status: null,
          StatusId: 0,
          Clasification: "",
          CustomerService: "",
          ContractStatus: 1,
          Zone: "",
          ContactNo: null,
          AttachmentFileName: null,
          AttachmentUrl: "",
          PaymentDay: null,
          ClientType: null,
          ActiveInPortal: 0,
          InactiveInPortal: 0,
          EmployeesQuantity: 0,
          PcQuantity: 0,
          VehiclesQuantity: 0,
          ClientQuantity: 0,
          WebPage: null,
          AnniversaryDate: null,
          ExpirationDate: null,
          lista: null
        },
        ContactCode: "",
        ContactName: null,
        ContactPhoneNumber: null,
        ContactEmail: null,
        Contact: {
          CustomerCode: null,
          ContactCode: "",
          Name: "",
          FullName: "  ",
          NameTwo: null,
          ContactAddress: "",
          ContactAddressTwo: null,
          City: null,
          PhoneNumber: "",
          MobilePhoneNumber: null,
          SalesPersonCode: null,
          LastDateModified: "",
          VatRegistrationNumber: null,
          Email: "",
          CompanyNumber: null,
          CompanyName: null,
          Type: 0,
          ExtensionNumber: null,
          FirstName: null,
          MiddleName: null,
          SurName: null,
          JobTitle: null,
          Blocked: 0,
          PictureDirectory: null,
          Birthday: "",
          ContactTypeEnum: 0,
          ContactJobResponsabilities: null,
          CompanyId: null
        },
        Diagnostic: "",
        Solution: "",
        prospect: null,
        CreatedBy: 0,
        CreatedAt: "",
        CreatedByUser: {
          IsEnabled: true,
          FirstName: "",
          LastName: "",
          BirthDate: null,
          SalesPersonCode: "",
          CompanySelected: "",
          FullName: "",
          Email: "",
          EmailConfirmed: false,
          PasswordHash: "",
          SecurityStamp: "",
          PhoneNumber: null,
          PhoneNumberConfirmed: false,
          TwoFactorEnabled: false,
          LockoutEndDateUtc: null,
          LockoutEnabled: false,
          AccessFailedCount: 0,
          Roles: [],
          Claims: [],
          Logins: [],
          Id: 0,
          UserName: ""
        },
        UpdatedBy: null,
        UpdatedByUser: null,
        LastUpdatedAt: "",
        Id: 0,
        IsEnabled: false,
        IsNull: false,
        FullNameValidation: ""
      }
    };
  },
  components: {
    quillEditor
  },
  methods: {
    getData() {
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });

      this.$http
        .get(`/api/serviceRequests/${this.id}/details`)
        .then((resp) => {
          loading.close();
          let response = resp.data;
          // setear valor del enum de acciones
          const action = resp.data.RequestsMovements.map((i) => {
            switch (i.Action) {
              case 2:
                i.Action = "Asignó la solicitud a un técnico";
                break;
              case 6:
                i.Action = "Agregó instaladores a la solicitud";
                break;
              case 7:
                i.Action = "Agregó dispositivos a la solicitud";
                break;
              case 11:
                i.Action = "Editando Dispositivos en solicitud";
                break;
              case 4:
                i.Action = "Cerró la solicitud";
                break;
              case 5:
                i.Action = "Validó la solicitud";
                break;
              case 8:
                i.Action = "Reabrió la solicitud";
                break;
              case 10:
                i.Action = "Actualizó el contrato de la solicitud";
                break;
              case 9:
                i.Action = "Canceló la solicitud";
                break;
              case 12:
                i.Action = "Actualizó el Inventario";
                break;
            }
            return { Action: i.Action, ...i };
          });
          response.RequestsMovements = action;
          this.data = resp.data;
          this.title = `Solicitud No. ${resp.data.Id}`;
          this.drawer = true;
        })
        .catch((err) => {
          loading.close();
          this.$alert(err.message, err.name, {
            type: "error"
          });
        });
    },
    draw(id) {
      // console.log("klkp pasa",this.open)
      this.open = true;
      this.id = id;
      this.getData();
    },
    handleDownload(file) {
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });

      if (file.url === "" || file.url === null || file.url === undefined) {
        // Aprovecho el return que tenia el bloque, para utilizarlo haciendo la peticion para Drive.
        let url = "/api/serviceRequests/DownloadFile?id=" + file.name;
        this.$http
          .get(url)
          .then((resp) => {
            loading.close();
            if (resp.status === 200) {
              let link = document.createElement("a");
              link.href = resp.data.ReasonPhrase;
              link.download = file;
              link.click();
            } else {
              const h = this.$createElement;
              this.$message({
                type: "info",
                message: h("p", null, [
                  h("span", null, "Documento no  "),
                  h("i", { style: "color: teal" }, "encontrado")
                ])
              });
            }
          })
          .catch((err) => {
            loading.close();
            this.$alert(err.message, err.name, {
              type: "error"
            });
          });
      } else {
        // Cuando estamos en DEV axios no tiene baseURL por tanto
        // se pasa aqui harcodeado.
        // let base;
        // if (process.env.NODE_ENV !== "development") {
        //   base = process.env.VUE_APP_API_URL;
        // } else {
        //   base = "http://localhost:44308";
        // }

        let link = document.createElement("a");
        // link.href = base + file.url;
        // link.download = base + file.url;
        link.href = file.url;
        link.download = file.url;
        link.target = "_blank";
        link.click();
        loading.close();
      }
      loading.close();
    },
    getFilePreview(fileName) {
      const fileNameList = fileName.split(".");
      const extension = fileNameList[fileNameList.length - 1];

      if (!extension) {
        return "https://www.pngitem.com/pimgs/m/465-4652909_blue-archive-icon-png-transparent-png.png";
      }

      try {
        if (extension != "pdf" && extension != "xls" && extension != "docx") {
          return "https://img.icons8.com/color/240/000000/google-drive.png";
        }
        return this.filePreview[extension];
      } catch (_) {
        return "https://cdn.icon-icons.com/icons2/1744/PNG/512/3643772-archive-archives-document-folder-open_113445.png";
      }
    }
  }
};
</script>

<style>
.el-drawer__header {
  margin-bottom: 20px !important;
}

.item {
  margin-top: -0px;
  margin-right: -40px;
}
</style>
